import * as z from "zod";

export const updateRecoverSettings = {
  name: "updateRecoverSettings" as const,
  input: z.object({
    brandName: z.string().optional(),
    excludeExternalSmsUnsubscribers: z.boolean().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
